import axios from 'axios'
import { withHeadersInstance } from './api-instance'
import qs from 'qs'

const baseUrl = process.env.VUE_APP_URL_API

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
}

export const GetTeachingArea = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/teaching-area/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PutTeachingArea = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/teaching-area/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteTeachingArea = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/teaching-area`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetList = async function(locationId, parameters) {
    try {
        if (locationId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: locationId')
            )

        // console.log('parameters', parameters)

        const url = `${baseUrl}/location/${locationId}/teaching-areas${
            parameters.Field ? '?' + qs.stringify(parameters) : '?getAll=true'
        }`

        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostTeachingArea = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/teaching-area`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
